export default "__VITE_ASSET__e6721c3a__"